import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Layers } from "lucide-react";

interface IShingleType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function ShingleType(props: IShingleType) {
    const { value, onChange, loading } = { ...props };
    const [shingleType, setShingleType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setShingleType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setShingleType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Shingle Type
            </Typography>

            <Select
                placeholder="Select shingle type"
                value={shingleType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Layers size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="3-Tab">3-Tab</Option>
                <Option value="Laminate Shingle">Laminate Shingle</Option>
                <Option value="Premium Laminate">Premium Laminate</Option>
                <Option value="Premium Laminate - Impact Res.">Premium Laminate - Impact Res.</Option>
                <Option value="Shake Look">Shake Look</Option>
            </Select>
        </Box>
    );
}
